<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="员工姓名" prop="name" style="margin-right:15px">
        <el-input v-model="form.name" readonly />
      </el-form-item>
      <el-form-item label="登录账号" prop="phone" style="margin-right:15px">
        <el-input v-model="form.phone" readonly />
      </el-form-item>
      <el-form-item label="所属机构" prop="groupName" style="margin-right:15px">
        <el-input v-model="groupName" readonly />
      </el-form-item>
      <el-form-item label="角色" style="margin-right:15px">
        <el-checkbox-group v-model="form.roleCodeList">
          <el-checkbox v-for="role in roleList" :key="role.code" :label="role.code" border>
            <span style="float:left">{{ role.roleName }}</span>
            <span style="float: right ; color: #8492a6; font-size: 12px">&nbsp;&nbsp;{{ role.branchName }}</span>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'

  export default {
    name: 'PartyEdit',
    data() {

      return {
        emptyForm: {},
        groupName:"",
        form: {
          name: '',
          phone: '',
          branchCode: '',
          departmentCode: '',
          teamCode: '',
          roleCodeList: []
        },
        roleList: [],
      }
    },
    created() {
      // 保存空表单对象
      this.emptyForm = JSON.parse(JSON.stringify(this.form))
    },
    methods: {

      // 获取页面信息
      getInfo(code) {
        // 查询到数据之前先展示空表单
        this.form = JSON.parse(JSON.stringify(this.emptyForm))
        request({url: `/ntocc-basic-api/userLogin/${code}`, method: 'get'}).then(response => {
          this.form = JSON.parse(JSON.stringify(response.data))
          if(this.form.branchName){
            this.groupName= this.form.branchName;
          }
          if(this.form.departmentName){
            this.groupName +="/";
            this.groupName +=this.form.departmentName
          }
          if(this.form.teamName){
            this. groupName +="/";
            this. groupName +=this.form.teamName
          }
        }).then(response => {
          const bc = this.form.branchCode;
            this.getRoleList(bc);
        }
        )
      },

      getRoleList(bc) {
        request({ url: `/ntocc-basic-api/role`, method: 'get', params: { 'type': 0,'branchCode':bc }}).then(r => {
          this.roleList = r.data.records
        })
      },
      // 提交
      funcSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            const rLoading = this.openLoading();
            const data = this.form
            request({url: '/ntocc-basic-api/userLogin', method: 'put', data}).then(response => {
              rLoading.close();
              this.$message({message: response.msg, type: 'success'})
              this.$emit('fatherEditMethod')
            })
          } else {
            return false
          }
        })
      },
      // 取消
      funcCancel() {
        this.$emit('fatherCancelMethod', 'edit')
      }

    }
  }
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
